const kidsCafeServiceInterests = [
  {
    name: 'interestBreakfast',
    label: 'Breakfast Service',
  },
  /*{
    name: 'interestBrunch',
    label: 'Brunch Service (10:00 am – 11:00 am)',
  },*/
  {
    name: 'interestLunch',
    label: 'Lunch Service',
  },
  /*{
    name: 'interestBogoLunch',
    label: 'BOGO Lunch Service (2:00 pm – 4:00 pm; receive a free Adult meal for every child served)',
  },*/
  {
    name: 'interestSnack',
    label: 'Snack Service',
  },
  {
    name: 'interestSupper',
    label: 'Supper Service',
  },
];

export default kidsCafeServiceInterests;
